module.exports = __webpack_public_path__ + "static/logo-749d875c7da01781e55ee1b5d813cbda.png";